<template>
  <app-navbar />
  <router-view v-slot="{ Component }">
    <transition name="page" mode="out-in">
      <component :is="Component" :key="$route.fullPath" />
    </transition>
  </router-view>
  <app-footer></app-footer>
  <back-to-top />
</template>

<script setup>
import { onMounted } from "vue";
import { useStore } from "vuex";
import AppNavbar from "@/components/AppNavbar.vue";
import AppFooter from "./components/AppFooter.vue";
import BackToTop from "./components/BackToTop.vue";

const store = useStore();

onMounted(() => {
  store.dispatch("initTheme");
});
</script>

<style lang="scss">
:root {
  --bg-primary: #f9f9f9;
  --bg-secondary: #ffffff;
  --bg-tertiary: #f4f4f4;
  --text-primary: #222222;
  --text-secondary: #777777;
  --text-tertiary: #999999;
  --border-color: #e0e0e0;
  --accent-color: #e67e22;
}

[data-theme="dark"] {
  --bg-primary: #1a1a1a;
  --bg-secondary: #242424;
  --bg-tertiary: #2d2d2d;
  --text-primary: #ffffff;
  --text-secondary: #b3b3b3;
  --text-tertiary: #808080;
  --border-color: #3a3a3a;
  --accent-color: #e67e22;
}

@-moz-document url-prefix() {
  :root {
    background-color: var(--bg-primary) !important;
  }
}

:root {
  background-color: var(--bg-primary) !important;
}

html {
  transition: background-color 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

body {
  transition: background-color 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    color 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-enter-active,
.page-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.page-enter-active {
  animation: pageIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-leave-active {
  animation: pageOut 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes pageIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pageOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>
